import React from 'react';
import '../../styles/AdminLoadingSpinner.css';

const AdminTableLoadingSpinner = () => (
  <div className="admin-table-loading-spinner__container">
    <div className="spinner" />
    <span className="loading-text">Loading...</span>
  </div>
);

export default AdminTableLoadingSpinner;